module.exports = __webpack_public_path__ + "static/media/doneDeal.940dcb49.svg";